import React, { useEffect } from 'react';
import { captureUtmParams } from '../utils/utmTracking';
/**
 * Silent component that captures UTM parameters on mount
 * Place this component at the top level of any landing page
 * No UI - just side effects
 */
export function UtmCapture() {
  useEffect(() => {
    // Capture UTM parameters from URL on component mount
    captureUtmParams();
  }, []);
  // No UI - this component is invisible
  return null;
}